<template>
  <div class="tw-h-full tw-w-full">
    <h3>Completed Subject Final Status Forms</h3>
    <span style="font-style: italic;">Approve for Closure</span> <br /><br />
    <!-- Filter Options above table -->
    <b-row>
      <b-col lg="4"></b-col>
      <b-col lg="4"></b-col>
      <b-col lg="4">
        <b-form-group
          label=""
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

      </b-col>
    </b-row>


    <b-table striped hover :fields="fields" :items="subjects" :filter="filter">
      <template v-slot:cell(name)="data">
        <b-link :href="data.item.case_link" target="_blank">{{ data.item.name }}</b-link>
      </template>
      <template v-slot:cell(approve)="data">
       
          <!-- Only show approve/decline buttons for new requests -->
          <b-button v-if="data.item.final_status == 'Final Status Form Completed'" @click="approve(data.index)" size="sm" variant="success" class="w-20">Approve</b-button>
          <b-button v-if="data.item.final_status == 'Final Status Form Completed'" @click="decline(data.index)" size="sm" variant="danger" class="w-20 ml-2">Decline</b-button>

          <!-- Otherwise, if it has been approved (and waiting for Final Status) -->
          <div v-if="data.item.final_status == 'Ready To Close'">
            Approved for closure on {{ data.item.last_status_changed }}
          </div>

          <!-- Otherwise, if it has been declined -->
          <div v-if="data.item.final_status == 'Declined'">
            Declined on {{ data.item.last_status_changed }}
          </div>

          <!-- And for those that are already completed... -->
          <div v-if="data.item.final_status == 'Closed'">
            Closed on {{ data.item.last_status_changed }}
          </div>
          
      </template>
    </b-table>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import { mapActions } from "vuex";

export default {
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
      fields: [
        { key: "name" },
        { key: "village" },
        { key: "reason" },
        { key: "last_followup_date"},
        { key: "approve", label: "Approve to Close"},
        { key: "final_status",  sortable: true, label: "Status"}
      ],
      subjects: [],
      componentKey: 0,
      filter: null,
    };
  },
  computed: {},
  mounted: function() {
    let that = this;
    HTTP.get("/kenya/subject_final_status/get_completed").then(response => {
      that.subjects = response.data;
    }).catch((error) => {
      HandleErrors.HandleErrors(error);
    });
  },
  methods: {
     ...mapActions('subjectfinalstatus', 
            ['getSubjectFinalCount', 'setSubjectFinalCount']),
     ...mapActions('subjectfinalstatuscompleted', 
            ['getSubjectFinalCompletedCount', 'setSubjectFinalCompletedCount']),
    refreshSideNavCount(){
      this.getSubjectFinalCount().then((response) => {
                this.setSubjectFinalCount(response.data);
            });
      
      this.getSubjectFinalCompletedCount().then((response) => {
                this.setSubjectFinalCompletedCount(response.data);
            });
    },
    approve: function(index){
      let that = this;
      HTTP.post("/kenya/subject_final_status/"+that.subjects[index].id+"/", {
        status: 'rclose'
      }).then(response => {
          that.subjects.splice(index, 1, response.data);
          that.refreshSideNavCount();
      });


    },
    decline: function(index){
      let that = this;
      HTTP.post("/kenya/subject_final_status/"+that.subjects[index].id+"/", {
        status: 'decline'
      }).then(response => {
          that.subjects.splice(index, 1, response.data);
          that.refreshSideNavCount();
      });
    }
  }
};
</script>

<style>
</style>